// redux/user/userThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  changeUserStatus,
  deleteUser,
  fetchUsers,
  getUserById,
  updateUser,
  deleteUserAll,
  changeUserVerificationStatus
} from "../../services/userService";
import { handleUnauthorized } from "../../utils/apiHelper";

export const fetchUserById = createAsyncThunk(
  "user/fetchById",
  async ({ id, navigate }, { rejectWithValue }) => {
    try {
      const { data } = await getUserById(id);
      console.log(data.user)
      return data.user;
    } catch (err) {
      if (err.response?.status === 401) {
        handleUnauthorized(navigate);
      }
      return rejectWithValue(err.message || "Failed to fetch user");
    }
  }
);

// Fetch all users with optional filters
export const fetchAllUsers = createAsyncThunk(
  "user/fetchUsersList",
  async ({ params, navigate }, { getState, rejectWithValue }) => {
    try {
      const { filters } = getState().user;
      const mergedParams = { ...filters, ...params }; 
      const { data } = await fetchUsers(mergedParams);
      return data;
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to fetch users");
    }
  }
);

// Update user by ID
export const updateUserById = createAsyncThunk(
  "user/update",
  async ({ id, data, navigate }, { rejectWithValue }) => {
    try {
      const res = await updateUser(id, data);
      return res.data.user;
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to update user");
    }
  }
);

// Change status (ban/unban)
export const toggleUserStatus = createAsyncThunk(
  "user/changeStatus",
  async ({ id, data, navigate }, { rejectWithValue }) => {
    try {
      const res = await changeUserStatus(id, data);
      return { id, status: res.data.status,}; // Return updated status and ID
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to change status");
    }
  }
);


// Change status (ban/unban)
export const toggleUserVerificationStatus = createAsyncThunk(
  "user/promoterVerifiedStatus",
  async ({ id, data, navigate }, { rejectWithValue }) => {
    try {
      const res = await changeUserVerificationStatus(id, data);
      return { id, status: res.data.status,}; // Return updated status and ID
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to change status");
    }
  }
);

// Delete user
export const deleteUserById = createAsyncThunk(
  "user/delete",
  async ({ id, navigate }, { rejectWithValue }) => {
    try {
      await deleteUser(id);
     return id 
   
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to delete user");
    }
  }
);


// Delete all user
export const deleteUserAlls = createAsyncThunk(
  "user/deleteall",
  async ({ id, navigate }, { rejectWithValue }) => {
    try {
      const response = await deleteUserAll(id);
     return response 
   
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to delete user");
    }
  }
);



